const apiCalls = [
  {
    "name": "CreateOrder",
    "description": "This action creates an order",
    "params": [
      {
        "key": "managerId",
        "options": {
          "type": "STRING",
          "required": false,
          "isArray": false
        }
      },
      {
        "key": "productId",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "utmSource",
        "options": {
          "type": "STRING",
          "required": false,
          "isArray": false
        }
      },
      {
        "key": "utmMedium",
        "options": {
          "type": "STRING",
          "required": false,
          "isArray": false
        }
      },
      {
        "key": "utmCampaign",
        "options": {
          "type": "STRING",
          "required": false,
          "isArray": false
        }
      }
    ]
  },
  {
    "name": "checkRisk",
    "description": "This action checks risk",
    "params": [
      {
        "key": "code",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "vin",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "userType",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      }
    ]
  },
  {
    "name": "checkContracts",
    "description": "This action checks contracts",
    "params": [
      {
        "key": "plateNumber",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      }
    ]
  },
  {
    "name": "AutocivilkaTariffCalculator",
    "description": "This action calculates autocivilka (OSCPVVNTZ) tariff",
    "params": [
      {
        "key": "flowCode",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "salesProgramCode",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "taxiUsage",
        "options": {
          "type": "BOOLEAN",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "privileges",
        "options": {
          "type": "BOOLEAN",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "discount",
        "options": {
          "type": "NUMBER",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "vehicleInsurerType",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "typePolicy",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "datePeriod",
        "options": {
          "type": "OPTION",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "vehicleType",
        "options": {
          "type": "OPTION",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "vehicleOwnerType",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "regUpr",
        "options": {
          "type": "NUMBER",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "iSspecialtransportUsage",
        "options": {
          "type": "BOOLEAN",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "basePremium",
        "options": {
          "type": "NUMBER",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "salesProgramCode_oscpv",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "deductible",
        "options": {
          "type": "NUMBER",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "useCity",
        "options": {
          "type": "NUMBER",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "bonusmalus",
        "options": {
          "type": "NUMBER",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "periodList",
        "options": {
          "type": "NUMBER",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "numberOfLosses",
        "options": {
          "type": "NUMBER",
          "required": true,
          "isArray": false
        }
      }
    ]
  },
  {
    "name": "AutozahistTariffCalculator",
    "description": "This action calculates autozahist (Autozahist) tariff",
    "params": [
      {
        "key": "flowCode",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "salesProgramCode",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "variant",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "americanCar",
        "options": {
          "type": "BOOLEAN",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "insuranceSum",
        "options": {
          "type": "NUMBER",
          "required": true,
          "isArray": false
        }
      }
    ]
  },
  {
    "name": "GreenCardTariffCalculator",
    "description": "This action calculates greenCard (GreenCard) tariff",
    "params": [
      {
        "key": "flowCode",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "salesProgramCode",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "datePeriod",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "vehicleType",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "useTerritory",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      }
    ]
  },
  {
    "name": "TravelTariffCalculator",
    "description": "This action calculates travel (VZK_NEW) tariff",
    "params": [
      {
        "key": "flowCode",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "salesProgramCode",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "countryTravelZone",
        "options": {
          "type": "OPTION",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "financialRisk_1_CoverageStatus",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "helpAssistance_16_CoverageStatus",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "helpAssistance_9_CoverageStatus",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "financialRisk_6_CoverageStatus",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "regularCustomer",
        "options": {
          "type": "BOOLEAN",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "helpAssistance_14_CoverageStatus",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "accident_1_CoverageStatus",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "helpAssistance_1_CoverageStatus",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "work",
        "options": {
          "type": "BOOLEAN",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "financialRisk_9_CoverageStatus",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "helpAssistance_6_CoverageStatus",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "placeOfStayAbroad",
        "options": {
          "type": "OPTION",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "helpAssistance_2_CoverageStatus",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "helpAssistance_13_CoverageStatus",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "helpAssistance_18_CoverageStatus",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "financialRisk_Currency",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "accident_3_CoverageStatus",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "accident_2_CoverageStatus",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "travelPurpose",
        "options": {
          "type": "OPTION",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "financialRisk_4_CoverageStatus",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "financialRisk_2_CoverageStatus",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "helpAssistance_Currency",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "civilCurrency",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "helpAssistance_12_CoverageStatus",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "civil_1_CoverageStatus",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "helpAssistance_3_CoverageStatus",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "civilSuminsured",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "accident_4_CoverageStatus",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "helpAssistance_4_CoverageStatus",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "helpAssistance_11_CoverageStatus",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "financialRisk_3_CoverageStatus",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "accident_5_CoverageStatus",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "civil_2_CoverageStatus",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "tariffIncrease",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "helpAssistance_15_CoverageStatus",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "daysAbroad",
        "options": {
          "type": "OPTION",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "helpAssistance_10_CoverageStatus",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "helpAssistance_5_CoverageStatus",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "insuredCount",
        "options": {
          "type": "NUMBER",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "helpAssistance_17_CoverageStatus",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "otherKof_k7",
        "options": {
          "type": "NUMBER",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "age",
        "options": {
          "type": "NUMBER",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "financialRisk_5_CoverageStatus",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "salesProgramCodeVZK",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "commision",
        "options": {
          "type": "NUMBER",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "helpAssistance_7_CoverageStatus",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "financialRisk_8_CoverageStatus",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "terrorism",
        "options": {
          "type": "BOOLEAN",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "suminsured_Accident",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "franchise",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "helpAssistance_8_CoverageStatus",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "financialRisk_7_CoverageStatus",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "helpAssistance_Suminsured",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "accident_6_CoverageStatus",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      }
    ]
  },
  {
    "name": "CrossDMSDTPTariffCalculator",
    "description": "This action calculates DMSDTP (DMSDTP) tariff",
    "params": [
      {
        "key": "flowCode_CrossDMSDTP",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "salesProgramCode_CrossDMSDTP",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "insuranceSumSZNH",
        "options": {
          "type": "STRING",
          "required": false,
          "isArray": false
        }
      },
      {
        "key": "insuranceSumDMS",
        "options": {
          "type": "NUMBER",
          "required": true,
          "isArray": true
        }
      },
      {
        "key": "salesProgramMScode",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "numberOfInsuredPersons",
        "options": {
          "type": "NUMBER",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "vehicleRegisterCity",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "datePeriod",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "selfSelling",
        "options": {
          "type": "BOOLEAN",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "vehicleType",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "otherKoef",
        "options": {
          "type": "NUMBER",
          "required": true,
          "isArray": false
        }
      }
    ]
  },
  {
    "name": "CrossLegkyiZahystTariffCalculator",
    "description": "This action calculates legkyi zahyst СВ-НВ (LegkyiZahyst) tariff",
    "params": [
      {
        "key": "flowCode_CrossLegkyiZahyst",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "salesProgramCode_CrossLegkyiZahyst",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "placeOfLaying",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "insuranceSumDCV",
        "options": {
          "type": "NUMBER",
          "required": true,
          "isArray": true
        }
      }
    ]
  },
  {
    "name": "AutocivilkaReservePolicyAction",
    "description": "This action reserves autocivilka in МТСБУ",
    "params": [
      {
        "key": "k1",
        "options": {
          "type": "NUMBER",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "k2",
        "options": {
          "type": "NUMBER",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "k3",
        "options": {
          "type": "NUMBER",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "k4",
        "options": {
          "type": "NUMBER",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "k5",
        "options": {
          "type": "NUMBER",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "k6",
        "options": {
          "type": "NUMBER",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "k7",
        "options": {
          "type": "NUMBER",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "k8",
        "options": {
          "type": "NUMBER",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "franchise",
        "options": {
          "type": "NUMBER",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "startDate",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "identCode",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "address",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "insPremium",
        "options": {
          "type": "NUMBER",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "surname",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "name",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "autoDescr",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "regNo",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "vin",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "prodYear",
        "options": {
          "type": "NUMBER",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "dateNextTO",
        "options": {
          "type": "STRING",
          "required": false,
          "isArray": false
        }
      },
      {
        "key": "birthDate",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "note",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "vehicleUsage",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "dbonusMalusID",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false,
          "allowedValues": [
            "0",
            "1",
            "2",
            "3",
            "4",
            "5",
            "6",
            "7",
            "8",
            "9",
            "10",
            "11",
            "12"
          ]
        }
      },
      {
        "key": "dcitizenStatusID",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "dcityID",
        "options": {
          "type": "NUMBER",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "dexpLimitID",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "dmarkID",
        "options": {
          "type": "NUMBER",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "dmodelID",
        "options": {
          "type": "NUMBER",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "dperiodID",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "dpersonStatusID",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "dprivelegeID",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "dsphereUseID",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "dvehicleTypeID",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false,
          "allowedValues": [
            "VehicleType.B1",
            "VehicleType.B2",
            "VehicleType.B3",
            "VehicleType.B3_1",
            "VehicleType.B3_2",
            "VehicleType.B4",
            "VehicleType.B5",
            "VehicleType.A1",
            "VehicleType.A2",
            "VehicleType.F"
          ]
        }
      },
      {
        "key": "pname",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      }
    ]
  },
  {
    "name": "GreenCardReservePolicyAction",
    "description": "This action reserves green card in МТСБУ",
    "params": [
      {
        "key": "periodId",
        "options": {
          "type": "NUMBER",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "startDate",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "identCode",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "surname",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "name",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "pName",
        "options": {
          "type": "STRING",
          "required": false,
          "isArray": false,
          "defaultValue": ""
        }
      },
      {
        "key": "address",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "personStatusId",
        "options": {
          "type": "NUMBER",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "birthDate",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "citizenStatusId",
        "options": {
          "type": "NUMBER",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "markId",
        "options": {
          "type": "NUMBER",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "regNo",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "vin",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "vehicleTypeId",
        "options": {
          "type": "NUMBER",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "city",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "note",
        "options": {
          "type": "STRING",
          "required": false,
          "isArray": false,
          "defaultValue": ""
        }
      },
      {
        "key": "autoDescr",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "zoneId",
        "options": {
          "type": "NUMBER",
          "required": true,
          "isArray": false
        }
      }
    ]
  },
  {
    "name": "SearchMtsbuMvs",
    "description": "This action performs a search in the MTSBU/MVS database to retrieve the required information.",
    "params": [
      {
        "key": "plateNumber",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      }
    ]
  },
  {
    "name": "performFinAP",
    "description": "Виконує перевірку FinAP.",
    "params": [
      {
        "key": "insuranceSum",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "firstName",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "lastName",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "middleName",
        "options": {
          "type": "STRING",
          "required": false,
          "isArray": false
        }
      },
      {
        "key": "birthDate",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "identCode",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      }
    ]
  },
  {
    "name": "VehicleBrand",
    "description": "This action find all vehicle brands",
    "params": []
  },
  {
    "name": "VehicleBrandModel",
    "description": "This action find all vehicle models by brand",
    "params": [
      {
        "key": "brand",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      }
    ]
  },
  {
    "name": "VehicleByNumberPlate",
    "description": "This action find vehicle by number plate in MTSBU",
    "params": [
      {
        "key": "plateNumber",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      }
    ]
  },
  {
    "name": "VehicleCountries",
    "description": "This action find all countries with vehicles",
    "params": []
  },
  {
    "name": "VehicleSearchCity",
    "description": "Отримати місто реєстрації авто з сол з кодами міст мтсбу (по першим символам пошук)",
    "params": [
      {
        "key": "registerCity",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      }
    ]
  },
  {
    "name": "Elastic",
    "description": "Універсальне апі для отримання всіх значень по коду довідника Еластіка",
    "params": [
      {
        "key": "elasticDictionaryCode",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      }
    ]
  },
  {
    "name": "ElasticCity",
    "description": "Отримання кодифікаторів міста",
    "params": [
      {
        "key": "city",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      }
    ]
  },
  {
    "name": "CheckORDLO",
    "description": "Апі для перевірки коду населеного пункта на ОРДЛО",
    "params": [
      {
        "key": "checkORDLOCode",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      }
    ]
  },
  {
    "name": "importBill",
    "description": "Import bill action",
    "params": []
  },
  {
    "name": "CreateCustomer",
    "description": "This action creates customer",
    "params": [
      {
        "key": "firstName",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "lastName",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "middleName",
        "options": {
          "type": "STRING",
          "required": false,
          "isArray": false
        }
      },
      {
        "key": "phoneNumber",
        "options": {
          "type": "STRING",
          "required": false,
          "isArray": false
        }
      },
      {
        "key": "email",
        "options": {
          "type": "STRING",
          "required": false,
          "isArray": false
        }
      },
      {
        "key": "birthDate",
        "options": {
          "type": "STRING",
          "required": false,
          "isArray": false
        }
      },
      {
        "key": "identCode",
        "options": {
          "type": "STRING",
          "required": false,
          "isArray": false
        }
      }
    ]
  },
  {
    "name": "SendIdentificationCode",
    "description": "Апі для відправки OTP коду",
    "params": [
      {
        "key": "phoneNumber",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "templateCode",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      }
    ]
  },
  {
    "name": "validatePromocode",
    "description": "Виконує перевірку промокоду.",
    "params": [
      {
        "key": "promocode",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "premium",
        "options": {
          "type": "NUMBER",
          "required": true,
          "isArray": false
        }
      }
    ]
  },
  {
    "name": "VerifyIdentificationCode",
    "description": "Апі для валідації OTP коду",
    "params": [
      {
        "key": "identificationCodeId",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      },
      {
        "key": "codeToVerify",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      }
    ]
  },
  {
    "name": "PickCrossesAction",
    "description": "This action creates many order-cross records in DB. It also removes all crosses that is not in pickedCrosses variable",
    "params": [
      {
        "key": "pickedCrosses",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": true
        }
      }
    ]
  },
  {
    "name": "PickCrossApiCall",
    "description": "This action creates one order-cross record in DB",
    "params": [
      {
        "key": "pickedCross",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      }
    ]
  },
  {
    "name": "RemovePickedCrossApiCall",
    "description": "This action remove one order-cross record from DB",
    "params": [
      {
        "key": "removePickedCross",
        "options": {
          "type": "STRING",
          "required": true,
          "isArray": false
        }
      }
    ]
  },
  {
    "name": "generatePrintoutOffer",
    "description": "Generate printout offer",
    "params": []
  },
  {
    "name": "createAndSignContract",
    "description": "Create and sign contract",
    "params": [
      {
        "key": "contractOfAgencyNumber",
        "options": {
          "type": "STRING",
          "required": false,
          "isArray": false
        }
      }
    ]
  },
  {
    "name": "CheckBlackList",
    "description": "Метод перевірки \"чорний список\"",
    "params": [
        {
            "key": "partyType",
            "options": {
                "type": "STRING",
                "required": true,
                "isArray": false
            }
        },
        {
            "key": "birthDate",
            "options": {
                "type": "STRING",
                "required": true,
                "isArray": false
            }
        },
        {
            "key": "givenName",
            "options": {
                "type": "STRING",
                "required": true,
                "isArray": false
            }
        },
        {
            "key": "surname",
            "options": {
                "type": "STRING",
                "required": true,
                "isArray": false
            }
        },
        {
            "key": "middleName",
            "options": {
                "type": "STRING",
                "required": true,
                "isArray": false
            }
        }
    ]
}
] as const;

export const apiCallsParamsMap = Object.fromEntries(
  apiCalls.map(({ name, params }) => [name, params]),
);

export enum ApiCallsTypes {
  CREATE_ORDER = "CreateOrder",
  CREATE_ORDER_CROSS_ACTION = "CreateOrderCrossAction",
  UPLOAD_CROSSES_TO_CONTEXT_INSTANCE_ACTION = "UploadCrossesToContextInstanceAction",
  OMPTL_CONFIRM_POLICY = "omtplConfirmPolicy",
  GREEN_CARD_CONFIRM_POLICY = "greenCardConfirmPolicy",
  GENERATE_PRINTOUT = "GeneratePrintout",
  CHECK_RISK = "checkRisk",
  CHECK_CONTRACTS = "checkContracts",
  AUTOCIVILKA_TARIFF_CALCULATOR = "AutocivilkaTariffCalculator",
  AUTOZAHIST_TARIFF_CALCULATOR = "AutozahistTariffCalculator",
  GREEN_CARD_TARIFF_CALCULATOR = "GreenCardTariffCalculator",
  TRAVEL_TARIFF_CALCULATOR = "TravelTariffCalculator",
  PICK_TRAVEL_TARIFF_CATEGORY_ACTION = "PickTravelTariffCategoryAction",
  CROSS_DMSDTPTARIFF_CALCULATOR = "CrossDMSDTPTariffCalculator",
  CROSS_LEGKYI_ZAHYST_TARIFF_CALCULATOR = "CrossLegkyiZahystTariffCalculator",
  AUTOCIVILKA_RESERVE_POLICY = "AutocivilkaReservePolicy",
  GREEN_CARD_RESERVE_POLICY = "GreenCardReservePolicy",
  SEARCH_MTSBUMVS = "SearchMtsbuMvs",
  GET_SERTIFICATE_META = "getSertificateMeta",
  CREATE_SIGN_OBJECT = "createSignObject",
  SIGNING_DOCUMENT = "signingDocument",
  VEHICLE_BRAND = "VehicleBrand",
  VEHICLE_BRAND_MODEL = "VehicleBrandModel",
  VEHICLE_BY_NUMBER_PLATE = "VehicleByNumberPlate",
  VEHICLE_COUNTRIES = "VehicleCountries",
  VEHICLE_SEARCH_CITY = "VehicleSearchCity",
  ELASTIC = "Elastic",
  ELASTIC_CITY = "ElasticCity",
  CHECK_ORDLO = "CheckORDLO",
  IMPORT_BILL = "importBill",
  IMPORT_BILL_STATUS = "importBillStatus",
  CREATE_CUSTOMER = "CreateCustomer",
  SEND_IDENTIFICATION_CODE = "SendIdentificationCode",
  SEND_EMAIL_IDENTIFICATION_CODE = "SendEmailIdentificationCode",
  VERIFY_IDENTIFICATION_CODE = "VerifyIdentificationCode",
  VERIFY_EMAIL_IDENTIFICATION_CODE = "VerifyEmailIdentificationCode",
  VALIDATE_PROMOCODE = "validatePromocode",
  PERFORM_FINAP_ACTION = "performFinAP",
  PICK_CROSSES_ACTION = "PickCrossesAction",
  CREATE_AND_SIGN_CONTRACT = "createAndSignContract",
  AUTOCIVILKA_LEAD_ACTION = "AutocivilkaLeadAction",
  GREEN_CARD_LEAD_ACTION = "GreenCardLeadAction",
  TRAVEL_LEAD_ACTION = "TravelLeadAction",
  AUTOZAHIST_LEAD_ACTION = "AutozahistLeadAction",
  CHECK_BLACK_LIST = "CheckBlackList",
}


export const leadActionNameMap: Record<string, ApiCallsTypes> = {
  VOSCPVVNTZ: ApiCallsTypes.AUTOCIVILKA_LEAD_ACTION,
  "GreenCard_01.01.2025": ApiCallsTypes.GREEN_CARD_LEAD_ACTION,
  Autozahist: ApiCallsTypes.AUTOZAHIST_LEAD_ACTION,
  VZK_NEW: ApiCallsTypes.TRAVEL_LEAD_ACTION,
};
